import FeedAddEVisit from './FeedAddEVisit'

export default FeedAddEVisit;
